import styles from './customDivider.module.scss';
import { mesParaAbreviacao } from '../../utils/mesParaAbreviacao';

interface ICustomDividerProps {
  step: number;
  mes?: number;
  ano?: number;
  hasDadosDeclaracao?: boolean;
}

function CustomDivider({ step, mes, ano, hasDadosDeclaracao = false }: ICustomDividerProps) {
  const idClass = step === 0 ? styles.active : step > 0 ? styles.done : '';
  const dadosDeclaracaoClass =
    step === (hasDadosDeclaracao ? 1 : -1) ? styles.active : step > (hasDadosDeclaracao ? 1 : 999) ? styles.done : '';
  const processoClass =
    step === (hasDadosDeclaracao ? 2 : 1) ? styles.active : step > (hasDadosDeclaracao ? 2 : 1) ? styles.done : '';
  const resumeClass =
    step === (hasDadosDeclaracao ? 3 : 2) ? styles.active : step > (hasDadosDeclaracao ? 3 : 2) ? styles.done : '';
  const sentClass =
    step === (hasDadosDeclaracao ? 4 : 3) ? styles.active : step > (hasDadosDeclaracao ? 4 : 3) ? styles.done : '';

  return (
    <>
      <div className={styles.mesAnoContainer}>
        <span className={styles.text}>Exercício:</span>
        <span className={styles.mesAno}>
          {mesParaAbreviacao(mes ?? parseInt(sessionStorage.getItem('mesDeclaracao') || '-1'))}{' '}
          {ano ?? sessionStorage.getItem('anoDeclaracao')}
        </span>
      </div>
      <div className={styles.dividerContainer}>
        <hr className={styles.dividerBigger} />
        <div className={styles.status}>
          <div className={`${styles.statusIcon} ${idClass}`}>
            <i className={`fas fa-id-card`} />
          </div>
          <span className={styles.statusText}>
            Identificação <br />
            Básica
          </span>
        </div>
        <hr className={`${styles.divider} ${idClass}`} />
        {hasDadosDeclaracao && (
          <>
            <div className={styles.status}>
              <div className={`${styles.statusIcon} ${dadosDeclaracaoClass}`}>
                <i className={`fas fa-file-contract`} />
              </div>
              <span className={styles.statusText}>
                Dados da
                <br />
                Declaração
              </span>
            </div>
            <hr className={`${styles.divider} ${dadosDeclaracaoClass}`} />
          </>
        )}
        <div className={styles.status}>
          <div className={`${styles.statusIcon} ${processoClass}`}>
            <i className={`fas fa-gem`} />
          </div>
          <span className={styles.statusText}>
            Processos
            <br />
            Minerário
          </span>
        </div>
        <hr className={`${styles.divider} ${processoClass}`} />
        <div className={styles.status}>
          <div className={`${styles.statusIcon} ${resumeClass}`}>
            <i className={`fas fa-tasks`} />
          </div>
          <span className={styles.statusText}>Resumo</span>
        </div>
        <hr className={`${styles.divider} ${resumeClass}`} />
        <div className={styles.status}>
          <div className={`${styles.statusIcon} ${sentClass}`}>
            <i className={`fas fa-paper-plane`} />
          </div>
          <span className={styles.statusText}>Recibo</span>
        </div>
      </div>
    </>
  );
}

export default CustomDivider;
